<div class="orange-divider"></div>
<footer class="big-footer">
  <div class="left">
    <a [routerLink]="['/intro']">
      <img src="../../assets/logo-white-animated.svg" alt="DOME Registry Logo"/>
      <p>DOME Registry</p>
    </a>
  </div>
  <div class="right">
    <div class="middle">
      <div class="middle-container">
        <p><a [routerLink]="['/intro']">Home</a></p>
        <p><a [routerLink]="['/stats']">Statistics</a></p>
        <p><a [routerLink]="['/about']">About us</a></p>
        <p><a [routerLink]="['/search']">Browse</a></p>
      </div>
      <div class="middle-container">
        <p><a [routerLink]="['/api']">API Documentation</a></p>
        <p><a [routerLink]="['/review']">Submit</a></p>
        <p><a href="https://www.youtube.com/watch?v=fmVppa9ESw0&t=2s&ab_channel=BioComputingUP" > Tutorial</a></p>
      </div>
    </div>
    <div class="right-right">
      <p><i class="bi bi-telephone-fill"></i>+39 546 789 126</p>
      <p class="text-decoration-underline"><i class="bi bi-envelope"></i> contact&#64;dome-ml.org</p>
      <p><a href="https://biocomputingup.it/"><i class="bi bi-building"></i>BioComputing Laboratory</a></p>
      <p><a href="https://github.com/BioComputingUP/dome-registry"><i class="bi bi-github"></i> GitHub Repository</a></p>
      <p><i class="bi bi-buildings"></i> Department of Biomedical Sciences - University of Padua, Italy</p>
      <p class="copyright"><i class="bi bi-c-circle"></i> 2025 DOME Registry</p>
    </div>
  </div>
</footer>
